var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "code-container clickable", attrs: { title: "Copy Code" } },
    [
      _c(
        "a",
        {
          directives: [
            {
              name: "clipboard",
              rawName: "v-clipboard",
              value: { copyText: _vm.code },
              expression: "{ copyText: code }"
            },
            {
              name: "tooltip",
              rawName: "v-tooltip.right",
              value: "Copy Code",
              expression: "'Copy Code'",
              modifiers: { right: true }
            }
          ],
          staticClass: "copy-code btn btn-function",
          attrs: { "tooltip-placement": "right", "aria-hidden": "true" },
          on: {
            click: function($event) {
              return _vm.showCopiedNotification()
            }
          }
        },
        [
          _c("i", {
            staticClass: "typcn typcn-tabs-outline",
            class: { "text-success": _vm.codeCopied }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "pre",
        {
          directives: [
            {
              name: "clipboard",
              rawName: "v-clipboard",
              value: { copyText: _vm.code },
              expression: "{ copyText: code }"
            }
          ],
          staticClass: "p-t-0 p-b-0 m-b-0",
          class: _vm.preClass,
          on: {
            click: function($event) {
              return _vm.handleCodeContainerClick()
            }
          }
        },
        [_vm._v("      "), _vm._t("default"), _vm._v("\n    ")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }